const en = {
    translation: {
        LOGIN: "Login",
        EMAIL: "Email",
        USERNAME: "Username",
        ENTER_USERNAME: "Enter your username",
        INVALID_EMAIL: "Enter a valid email address",
        ENTER_EMAIL: "Enter your email address",
        ENTER_PASSWORD: "Enter your password",
        PASSWORD: "Password",
        FORGOT_PASSWORD: "Forgot Password",
        RESET_PASSWORD: "Reset Password",
        PASSWORD_RESET_LINK_SENT: "Password reset link sent.",
        LOGIN_FAILED: "Login failed. Please check your details.",
        DASHBOARD: "Dashboard",
        SETTINGS: "Settings",
        GREETING: "Hello, {{name}}",
        MENU_FILE: "File",
        MENU_FILE_SETTINGS: "Settings",
        MENU_FILE_PROPAGATION_MODEL: "Propagation Model Settings",
        MENU_VIEW: "View",
        MENU_DB: "Database",
        MENU_DB_LOAD: "Load Transmitter/Receiver",
        MENU_CALCULATIONS: "Calculations",
        MENU_CALCULATIONS_INTERFERENCE: "Interference Analysis",
        MENU_CALCULATIONS_CI: "C/I Frequency Check",
        MENU_CALCULATIONS_TI: "T/I Frequency Check",
        MENU_CALCULATIONS_IN: "I/N Frequency Check",
        MENU_CALCULATIONS_TD: "TD Frequency Check",
        MENU_CALCULATIONS_FIELD_COMPATIBILITY: "Field Compatibility Check",
        MENU_CALCULATIONS_LINK_COMPATIBILITY: "Link Compatibility Check",
        MENU_CALCULATIONS_INTERMODULATION: "Intermodulation Analysis",
        MENU_CALCULATIONS_INTERMODULATION_FREQUENCY: "Intermodulation Frequency Check",
        MENU_CALCULATIONS_POINT_FIELD_INTENSITY: "Point Field Intensity",
        MENU_CALCULATIONS_SAFETY_ZONE: "Safety Zone Calculations",
        MENU_CALCULATIONS_SINGLE_SIGNAL: "Single Signal Safety Zone",
        MENU_CALCULATIONS_MULTI_SIGNAL: "Multi Signal Safety Zone",
        MENU_CALCULATIONS_SHORTWAVE: "Shortwave Frequencies",
        MENU_CALCULATIONS_VECTOR: "Vector Calculations",
        MENU_CALCULATIONS_VECTOR_CONTROL_STATION: "Vector Control Station",
        MENU_CALCULATIONS_VECTOR_CONTROL_LINK: "Vector Control Link",
        MENU_CALCULATIONS_AREA: "Area Calculations",
        MENU_CALCULATIONS_AREA_FIELD_INTENSITY: "Area Field Intensity",
        MENU_CALCULATIONS_AREA_CI: "C/I Interference",
        MENU_CALCULATIONS_AREA_TI: "T/I Interference",
        MENU_CALCULATIONS_AREA_IN: "I/N Interference",
        MENU_CALCULATIONS_AREA_PROCESSOR: "Processor",
        MENU_CALCULATIONS_AREA_LOW_FREQUENCY: "Low Frequency Mixed Mode",
        MENU_CALCULATIONS_AREA_SATELLITE: "Satellite Line of Sight",
        MENU_TASKS: "Tasks",
        MENU_COORDINATION: "Coordination",
        MENU_NOTIFICATION: "Notification",
        MENU_VIEWING: "Viewing",
        MENU_TEST_OBJECT: "Test Object",
        MENU_TEST_CREATE_TRANSMITTERS: "Create Test Transmitters",
        MENU_TEST_CREATE_RECEIVERS: "Create Test Receivers",
        MENU_TEST_CREATE_STATION: "Create Test Station",
        MENU_TEST_CREATE_LINK: "Create Link",
        MENU_GPS: "GPS",
        MENU_TOOLS: "Tools",
        MENU_ICAO: "ICAO",
        MENU_WINDOW: "Window",
        MENU_HELP: "Help",
        CHECKBOX_OPTION_1: "Option 1",
        CHECKBOX_OPTION_2: "Option 2",
        CHECKBOX_OPTION_3: "Option 3",
        CHECKBOX_OPTION_4: "Option 4",
        CHECKBOX_OPTION_5: "Option 5",
        CHECKBOX_OPTION_6: "Option 6",
        FILE_UPLOAD_TITLE: "File Upload",
        MAP_TITLE: "Map",
        UPLOAD_BUTTON: "Upload",
        MENU_TRANSMITTERS: "Transmitters",
        MENU_RECEIVERS: "Receivers",
        MENU_COM_OBJECTS: "COM Objects",
        MENU_VECTOR_RESULTS: "Vector Results",
        MENU_SENDER_RECEIVER_LINKS: "Sender-Receiver Links",
        MENU_VECTORS: "Vectors",
        MENU_FAP_VECTORS: "FAP Vectors",
        MENU_COVERAGE_AREAS: "Coverage Areas",
        MENU_NEAR_AREAS: "Near Areas",
        MENU_SAFETY_ZONE_AREA: "Safety Zone Area",
        MENU_HEIGHT_AREAS: "Height Areas",
        MENU_HORIZON_AREAS: "Horizon Areas",
        MENU_PROTECTED_SERVICE: "Protected Service",
        MENU_AREA_RESULTS: "Area Results",
        MENU_MAP_LAYERS: "Map Layers",
        MENU_MAP_OSM: "OSM Map 5m - Turkey 200km",
        MENU_MAP_DSM: "DSM 50m Turkey",
        MENU_OBSTACLE_LAYERS: "Obstacle Layers",
        LOGIN_SUCCESS: "Login successful. Welcome!",
        SUCCESS: "Success",
        ERROR: "Error",
        MEASUREMENT_FIELDS: "Measurement Fields",
        ADD_MEASUREMENT_FIELD: "Add Measurement Field",
        EDIT_MEASUREMENT_FIELD: "Edit Measurement Field",
        FIELD_NAME: "Field Name",
        REQUIRED: "Required",
        ACTIONS: "Actions",
        EDIT: "Edit",
        DELETE: "Delete",
        YES: "Yes",
        NO: "No",
        DELETE_CONFIRMATION: "Delete Confirmation",
        DELETE_MEASUREMENT_FIELD_CONFIRM: "Are you sure you want to delete this measurement field?",
        MEASUREMENT_FIELD_ADDED: "Measurement field added successfully.",
        MEASUREMENT_FIELD_UPDATED: "Measurement field updated successfully.",
        MEASUREMENT_FIELD_DELETED: "Measurement field deleted successfully.",
        PLEASE_ENTER_FIELD_NAME: "Please enter field name",
        ENTER_FIELD_NAME: "Enter field name",
        FIELD_NAME_MIN_LENGTH: "Field name must be at least 2 characters",
        FIELD_NAME_MAX_LENGTH: "Field name can be maximum 50 characters",
        ITEMS: "items",
        STUDENT_MEASUREMENTS: "Student Measurements",
        SELECT_STUDENT: "Select Student",
        ADD_MEASUREMENT: "Add Measurement",
        EDIT_MEASUREMENT: "Edit Measurement",
        MEASUREMENT_DATE: "Measurement Date",
        MEASUREMENT_VALUES: "Measurement Values",
        MEASUREMENTS_FOR: "Measurements for",
        PLEASE_SELECT_STUDENT: "Please select a student first",
        MEASUREMENT_ADDED: "Measurement added successfully.",
        MEASUREMENT_UPDATED: "Measurement updated successfully.",
        MEASUREMENT_DELETED: "Measurement deleted successfully.",
        DELETE_MEASUREMENT_CONFIRM: "Are you sure you want to delete this measurement?",
        PLEASE_ENTER_MEASUREMENT_DATE: "Please enter measurement date",
        PLEASE_ENTER_VALUE: "Please enter value",
        ENTER_VALUE: "Enter value",
        WARNING: "Warning",
        ADD_NEW_MEASUREMENT: "Add New Measurement",
        SAVE_MEASUREMENT: "Save Measurement",
        PLEASE_ENTER_AT_LEAST_ONE_VALUE: "Please enter at least one value",
        EDIT_MEASUREMENT_DESCRIPTION: "Edit measurement information",
    },
};

export default en;